<template>
    <PageContainer>
        <PageHeader>
            {{ $t('issueLog.ticket.page_title') }} - <b>{{ $t('issueLog.type.'+log.issue_type) }}</b>
        </PageHeader>

        <div class="row mt-5">
            <div class="offset-md-3 col-md-6 py-3 ticket-bg" ref="pdfContent">
                <div class="row my-3">
                    <div class="col-12 text-center">
                        <AppLogo />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6">
                        {{ log.customer_name }} {{ log.customer_lastname }}
                    </div>
                    <div class="col-6 text-end">
                        {{ log.created_at }}
                    </div>
                    <div class="col-6">
                        {{ log.customer_document }}
                    </div>
                    <div class="col-6 text-end">
                        {{ $t('issueLog.type.'+log.issue_type) }}
                    </div>
                </div>

                <div class="row fw-bold product-text-size">
                    <div class="col-9">{{ $t('ticket.product_list') }}</div>
                    <div class="col-3 text-end">{{ $t('ticket.quantity') }}</div>
                </div>

                <div class="row product-text-size my-1" v-for="product in log.items">
                    <div class="col-9 text-nowrap">
                        {{ product.product.name + " - " + product.size.size }}
                    </div>
                    <div class="col-3 text-end">
                        {{ product.quantity }}
                    </div>
                </div>

                <div class="row my-3">
                    <div class="col-12 fs-7 text-muted" v-html="$t('ticket.sign_text')">
                    </div>
                </div>

                <div class="row pt-3">
                    <div class="offset-1 col-10 text-center">
                        <img
                            :src="log.sign"
                            class="img-fluid"
                            alt="sign image"
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="offset-md-4 col-md-4">
                <div class="d-flex flex-row justify-content-between">
                    <BackButton :href="`/issueLogs/${log.issue_type}`"/>
                    <PrintButton :pdf-content="pdfContent" />
                </div>
            </div>
        </div>
    </PageContainer>
</template>

<script setup lang="ts">
import type {IssuedLogInterface} from "@/components/helpers/Interfaces.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import {ref} from 'vue'
import PrintButton from "@/components/buttons/PrintButton.vue";
import AppLogo from "@/components/elements/appLogo.vue";

const {log} = defineProps<{
    log: IssuedLogInterface,
}>()

const pdfContent = ref(null)
</script>

<style scoped>
.ticket-bg {
    border: 1px solid #e6e6e6;
}

.product-text-size{
    font-size: 0.8rem !important;
}
</style>
